'use client';

import { useNavigate } from 'react-router-dom';

import { WithResponsiveProps } from '../utils/withResponsive';

import { MoreInfoButton } from './MoreInfoButton';

import { Button } from '@/components';
import ROUTES from '@/router/routes';
import { SelectedScreen } from '@/types/editProfile';
import type { ResponseInfoFeoroUsuario } from '@/types/goldDate';

interface ActionButtonsProps extends WithResponsiveProps {
  dataProps?: ResponseInfoFeoroUsuario;
}

export const ActionButtonsList = ({ dataProps }: ActionButtonsProps) => {
  const navigate = useNavigate();

  const handleParticipateMore = () => {
    // paso state para saber que estoy en fecha de oro sino llamo request de datos
    navigate(ROUTES.goldDate.home, { state: true });
  };

  const handleModifyCBU = () => {
    navigate(ROUTES.editAccount.myCBU, {
      state: {
        selectedScreen: 'MyCBU',
        returnPage: ROUTES.goldDate.list,
      } as SelectedScreen,
    });
  };

  return (
    <div className="lg:mt-4 mt-8 text-center lg:text-left lg:space-y-0 lg:space-x-6 flex lg:flex-row flex-col space-y-3">
      {dataProps?.inscripcionPosible && !dataProps?.participaActual && (
        <Button
          className="text-gdt-blue font-bold"
          type="button"
          variant="text"
          onClick={handleParticipateMore}
        >
          Participar de más Torneos Fecha de Oro
        </Button>
      )}

      <Button
        className="text-gdt-blue font-bold"
        type="button"
        variant="text"
        onClick={handleModifyCBU}
      >
        Modificar datos del CBU
      </Button>

      <MoreInfoButton />
    </div>
  );
};
